'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';
import { isAuthenticated } from 'services/identity.service';
import isProtectedRoute from 'services/security.service';

const WithAuth = ({ children }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const fullPath =
    pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');

  const isNotAuthenticated = !isAuthenticated();
  const isAuthenticationNeeded =
    isProtectedRoute(pathname) && isNotAuthenticated;

  useEffect(() => {
    if (isAuthenticationNeeded) {
      const loginPageURLWithRedirectionInfo = getPageURL({
        pageName: ROUTE_CONFIG.LOGIN.label,
        queryParams: {
          redirectTo: encodeURIComponent(fullPath)
        }
      });

      router.replace(loginPageURLWithRedirectionInfo);
    }
  }, [isAuthenticationNeeded, fullPath, router]);

  if (isAuthenticationNeeded) {
    return (
      <div className='flex h-screen w-screen items-center justify-center'>
        Loading...
      </div>
    );
  }

  return children;
};

export default WithAuth;
